<template lang='pug'>
div
  input.is-checkradio(type='checkbox' v-model='local_value' :value='checkbox_value' :id="html_id" :disabled='disabled' :role='role')
  label(:for='html_id'): slot
</template>

<script>

export default {
  name: 'SmCheckbox',
  data() {
    return {
      html_id: 'checkbox' + this._uid
    }
  },
  computed: {
    local_value: {
      get() { return this.value },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  props: ['checkbox_value', 'value', 'disabled', 'role']
}
</script>
